// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import ElementLocale from 'element-ui/lib/locale'
import '@/assets/icon/iconfont.css'
import '@/assets/css/reset.css'
import '@/assets/css/global.css'
import {
  Button,
  Input,
  Checkbox,
  Container,
  Footer,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  Switch,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Popover,
  Tooltip,
  Message,
  Select,
  Option,
  Form,
  FormItem,
  Radio,
  RadioButton,
  RadioGroup,
  Link,
  ColorPicker,
  loading,
  Table,
  TableColumn,
  Pagination,
  MessageBox,
  Badge
} from 'element-ui'
import {
  LoginCtrl,
  LoginArea,
  LoginPage,
  RegisterCtrl,
  ZWSHome,
  ZWSHeader,
  ZWSAside,
  ZWSMain,
  ZWSFooter,
  ThemePicker

} from '../third_party/common_app'
import zlgcloudhelper from './native/zlgcloudhelper'

Vue
  // element-ui 组件
  .use(VueI18n)
  .use(Button)
  .use(Select)
  .use(Option)
  .use(Input)
  .use(Checkbox)
  .use(Container)
  .use(Footer)
  .use(Header)
  .use(Aside)
  .use(Main)
  .use(Menu)
  .use(Submenu)
  .use(Switch)
  .use(MenuItem)
  .use(MenuItemGroup)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Dialog)
  .use(Popover)
  .use(Tooltip)
  .use(Form)
  .use(FormItem)
  .use(Radio)
  .use(RadioButton)
  .use(RadioGroup)
  .use(Link)
  .use(ColorPicker)
  .use(loading)
  .use(Table)
  .use(TableColumn)
  .use(Pagination)
  .use(Badge)

  // ZWS 组件
  .use(LoginCtrl)
  .use(LoginArea)
  .use(LoginPage)
  .use(RegisterCtrl)
  .use(ZWSHome)
  .use(ZWSHeader)
  .use(ZWSAside)
  .use(ZWSMain)
  .use(ZWSFooter)
  .use(ThemePicker)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$zlgcloudhelper = zlgcloudhelper
Vue.prototype.$message = Message
Vue.prototype.$axios = axios
Vue.prototype.bus = new Vue()
Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: localStorage.getItem('zlg_label_userinfo') && JSON.parse(localStorage.getItem('zlg_label_userinfo')).language
    ? JSON.parse(localStorage.getItem('zlg_label_userinfo')).language
    : 'zh',
  messages: {
    'zh': Object.assign(
      require('ZWSModule/Common/ZWSLanguages/api-zh.json'),
      require('ZWSModule/Common/ZWSLanguages/system-zh.json'),
      require('ZWSModule/Common/ZWSLanguages/common-zh.json'), zhLocale),
    'en': Object.assign(
      require('ZWSModule/Common/ZWSLanguages/api-en.json'),
      require('ZWSModule/Common/ZWSLanguages/system-en.json'),
      require('ZWSModule/Common/ZWSLanguages/common-en.json'), enLocale),
    'tw': Object.assign(require('ZWSModule/Common/ZWSLanguages/system-tw.json'),
      require('ZWSModule/Common/ZWSLanguages/common-tw.json'),
      require('ZWSModule/Common/ZWSLanguages/api-tw.json'), twLocale)
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: {
//     App
//   },
//   template: '<App/>'
// })
// runtime

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js